<template>
  <validation-observer ref="simpleRules">
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Genel</span>
        </template>
        <b-card title="Hakkımızda">
          <b-row>
            <b-col cols="12">
              <title-text />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
              <sub-title-text />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
              <slogan-text />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
              <country-text />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
              <year-text />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
              <video-embed />
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
              <video-card />
            </b-col>
            <b-col
              cols="12"
            >
              <content-text />
            </b-col>
            <b-col
              cols="12"
            >
              <text1-content />
            </b-col>
            <b-col
              cols="12"
            >
              <text2-content />
            </b-col>
            <b-col  cols="12">
              <mission-content />
            </b-col>
            <b-col  cols="12">
              <vision-content />
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <b-col
              cols="12"
              md="6"
          >
            <image-card />
          </b-col>
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="3"-->
<!--          >-->
<!--            <image-card2 />-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="3"-->
<!--          >-->
<!--            <image-card3 />-->
<!--          </b-col>-->
          <b-col
              cols="12"
              md="6"
          >
            <catalog-card />
          </b-col>
        </b-row>

      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Değerlerimiz</span>
        </template>
        <items-card />
      </b-tab>
    </b-tabs>

    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTabs, BTab,
} from 'bootstrap-vue'

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TitleText from '@/views/Admin/About/elements/TitleText.vue'
import ContentText from '@/views/Admin/About/elements/ContentText.vue'
import ImageCard from '@/views/Admin/About/elements/ImageCard.vue'
import ImageCard2 from '@/views/Admin/About/elements/ImageCard2.vue'
import ImageCard3 from '@/views/Admin/About/elements/ImageCard3.vue'
import ItemsCard from '@/views/Admin/About/elements/itemsCard.vue'
import Text1Content from "@/views/Admin/About/elements/Text1Content.vue";
import Text2Content from "@/views/Admin/About/elements/Text2Content.vue";
import SubTitleText from "@/views/Admin/About/elements/SubTitleText.vue";
import SloganText from "@/views/Admin/About/elements/SloganText.vue";
import VideoEmbed from "@/views/Admin/About/elements/VideoEmbed.vue";
import VideoCard from "@/views/Admin/About/elements/VideoCard.vue";
import CatalogCard from "@/views/Admin/About/elements/CatalogCard.vue";
import CountryText from "@/views/Admin/About/elements/CountryText.vue";
import YearText from "@/views/Admin/About/elements/YearText.vue";
import MissionContent from "@/views/Admin/About/elements/MissionContent.vue";
import VisionContent from "@/views/Admin/About/elements/VisionContent.vue";

export default {
  name: 'Index',
  components: {
    VisionContent,
    MissionContent,
    YearText,
    CountryText,
    CatalogCard,
    VideoCard,
    VideoEmbed,
    SubTitleText,
    SloganText,
    Text2Content,
    Text1Content,
    ItemsCard,
    BTab,
    BTabs,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    ContentText,
    ImageCard,
    ImageCard2,
    ImageCard3,
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      itemsForm: false,
      selectItems: null,

    }
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
    saveData() {
      return this.$store.getters['about/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getData()
    },
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('about/getDataItem')
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('about/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
